import React from 'react'
import PropTypes from 'prop-types'
import styles from './ErrorContainer.module.scss'
import { ReactComponent as InfoIcon } from '../../assets/media/icons/info.svg'

const ErrorContainer = props => {
    return (
        <div className={styles.errorContainer}>
            <div className={styles.errorWrapper}>
                <InfoIcon aria-hidden='true' focusable='false' role='img'  />
                <p className={styles.errorMessage}>{props.errorMessage}</p>
            </div>
        </div>
    )
}

ErrorContainer.propTypes = {
    errorMessage: PropTypes.string
}

export default ErrorContainer
